// Util per Mapbox Search Box API (autocomplete indirizzi).
// Scope limitato a IT. Documentazione:
// https://docs.mapbox.com/api/search/search-box/

export interface MapboxSuggestion {
    mapbox_id: string;
    name: string;              // es. "Piazza del Popolo"
    place_formatted: string;   // es. "Roma, Lazio, Italia"
    full_address?: string;
}

export interface MapboxRetrieved {
    mapbox_id: string;
    name: string;
    full_address: string;
    lng: number;
    lat: number;
}

export interface MapboxSearchConfig {
    token: string;
    sessionToken: string;  // per batching richieste di una stessa sessione (pricing)
}

const BASE = 'https://api.mapbox.com/search/searchbox/v1';

export async function mapboxSuggest(
    query: string,
    cfg: MapboxSearchConfig,
): Promise<MapboxSuggestion[]> {
    if (!query.trim()) return [];
    const url = new URL(`${BASE}/suggest`);
    url.searchParams.set('q', query);
    url.searchParams.set('access_token', cfg.token);
    url.searchParams.set('session_token', cfg.sessionToken);
    url.searchParams.set('country', 'IT');
    url.searchParams.set('language', 'it');
    url.searchParams.set('limit', '6');

    const res = await fetch(url);
    if (!res.ok) throw new Error(`Mapbox suggest failed: ${res.status}`);
    const json = (await res.json()) as { suggestions?: MapboxSuggestion[] };
    return json.suggestions ?? [];
}

export async function mapboxRetrieve(
    mapboxId: string,
    cfg: MapboxSearchConfig,
): Promise<MapboxRetrieved | null> {
    const url = new URL(`${BASE}/retrieve/${encodeURIComponent(mapboxId)}`);
    url.searchParams.set('access_token', cfg.token);
    url.searchParams.set('session_token', cfg.sessionToken);

    const res = await fetch(url);
    if (!res.ok) throw new Error(`Mapbox retrieve failed: ${res.status}`);
    const json = (await res.json()) as {
        features?: Array<{
            properties: { mapbox_id: string; name: string; full_address: string };
            geometry: { coordinates: [number, number] };
        }>;
    };
    const f = json.features?.[0];
    if (!f) return null;
    return {
        mapbox_id: f.properties.mapbox_id,
        name: f.properties.name,
        full_address: f.properties.full_address,
        lng: f.geometry.coordinates[0],
        lat: f.geometry.coordinates[1],
    };
}

export function newSessionToken(): string {
    return crypto.randomUUID();
}
